<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <div class="filter__name">月份：</div>
            <el-date-picker
              v-model="filters.dateTime"
              type="monthrange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :picker-options="pickerOptions">
            </el-date-picker>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700" :summary-method="getSummaries" show-summary>
      <el-table-column prop="month" label="月份" width="" align="center">
      </el-table-column>
      <el-table-column label="总数据（排除丢单）">
        <el-table-column prop="ocount" label="订单数" width="" align="center">
        </el-table-column>
        <el-table-column prop="payment" label="金额" width="" align="center">
        </el-table-column>
        <el-table-column prop="income" label="收入" width="" align="center">
        </el-table-column>
        <el-table-column prop="commission" label="佣金" width="" align="center">
        </el-table-column>
        <el-table-column prop="profit" label="利润" width="" align="center">
        </el-table-column>
        <el-table-column prop="apply" label="请款" width="" align="center">
        </el-table-column>
        <el-table-column prop="receive" label="收款" width="" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column label="进行中">
        <el-table-column prop="running_ocount" label="订单数" width="" align="center">
        </el-table-column>
        <el-table-column prop="running_payment" label="金额" width="" align="center">
        </el-table-column>
        <el-table-column prop="running_commission" label="佣金" width="" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column label="提现">
        <el-table-column prop="apply_ocount" label="订单数" width="" align="center">
        </el-table-column>
        <el-table-column prop="apply_payment" label="金额" width="" align="center">
        </el-table-column>
        <el-table-column prop="apply_income" label="收入" width="" align="center">
        </el-table-column>
        <el-table-column prop="apply_commission" label="佣金" width="" align="center">
        </el-table-column>
      </el-table-column>
    </el-table>
  </article>
</template>

<script>
import {adMonthSummary} from '../../api/api'
import util from '../../script/util'
export default {
  name: 'adMonthSummary',
  data () {
    return {
      filters: {
        dateTime: '',
        start_time: '',
        end_time: ''
      },
      lists: [],
      listLoading: false,
      pickerOptions: {
        shortcuts: [{
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '一年内',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 12)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!['month'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    dateTimeChange () {
      this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
      this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
    },
    getList () {
      let filters = this.filters
      let params = {
        start_time: filters.start_time,
        end_time: filters.end_time
      }

      this.listLoading = true
      adMonthSummary(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    const date = new Date()
    const start = new Date(date.getFullYear(), date.getMonth() - 12, 1)
    const end = new Date(date.getFullYear(), date.getMonth(), 1)

    this.filters.dateTime = [start, end]
    this.dateTimeChange()

    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.dateTime': 'dateTimeChange',
    'filters.start_time': 'getList',
    'filters.end_time': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/data/adMonthSummary.vue